import React, { useCallback, useEffect, useRef, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import { getFromSessionStorage, getVisibleFormFields, handleError, stopBackgroundScrolling } from 'common/utils/app.utils';
import { CONTACT_DETAILS_FORM_CONFIG } from 'featureLib/OrderDetails/formConfig';
import { FormBuilder, IFORM } from 'featureLib';
import { isFormValid } from 'featureLib/FormBuilder/form.validator';
import { createUpdateKdmDetailsHandlerAOI } from 'tokenGeneration/response.handler';
import { fetchOrder, updateOrderForSummary } from 'home/view/manage-feasibility/services';
import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import Loader from 'common/utils/loader-service';
import { error } from 'console';
// import './customModalKdm.scss'

const CustomModalKdm = (props: any) => {
  let {
    kdmInfo,
    setKdmInfo,
    order,
    fetchOrderFn,
    // reRenderComponent,
    customPopupTitle = 'Update KDM Details',
    customPopupMsg = '',
    closeCustomPopup,
    onLoad,
    isLoading = false,
    onUpdateSuccess = () => {}
  } = props;
  const [disableBtn, setDisableBtn] = useState(true);
  const [contactFormState, setContactFormState] = useState<any>(() => CONTACT_DETAILS_FORM_CONFIG);
  const [showError, setShowError] = useState(false);

  // const kdmInfoObj = order?.lead?.customer?.authorizedSignatory;
  const kdmInfoObj = { ...kdmInfo };

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  const onSuccessCb = (orderDetails: any) => {
    const leadDetails = orderDetails?.lead?.customer?.authorizedSignatory || order?.lead?.customer?.authorizedSignatory;
    setKdmInfo(leadDetails);
    onUpdateSuccess(orderDetails || order);
  };

  const KdmInfoSetter = () => {
    fetchOrder(summaryAuthToken).then(
      (res: any) => {
        // const leadDetails = res?.res?.data?.result?.lead?.customer?.authorizedSignatory;
        fetchOrderFn(null, summaryAuthToken, onSuccessCb);
      },
      (error: any) => {
        console.log(error);
      }
    );
  };

  const handleContactFormChange = ({ field, value, oldValue, newValue, form }: { field: string; value: any; oldValue: any; newValue: any; form: IFORM }) => {
    setShowError(false);
    setDisableBtn(false);
    // if (oldValue?.key === newValue?.key) {
    //   setDisableBtn(true);
    // }
  };

  const onContactFieldChange = useCallback(
    (
      field: string,
      value: any,
      initialState: any,
      { setForm, form, disableAll, oldValue, newValue }: { setForm: Function; form: IFORM; disableAll: Function; oldValue: any; newValue: any }
    ) => {
      handleContactFormChange({ form, field, value, oldValue, newValue });
    },
    []
  );

  const prepareKdmDetailsPayload = (formSchema: IFORM) => {
    const request = {} as any;
    const payload = {} as any;
    request['emailId'] = formSchema['emailAddress'].value;
    request['contactNumber'] = formSchema['phoneNumber'].value;
    request['name'] = formSchema['fullName'].value;

    payload['authorizedSignatory'] = request;
    return payload;
  };

  const onSubmitContact = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setContactFormState(form?.values);
  }, []);

  const closeCustomModal = () => {
    stopBackgroundScrolling(false);
    closeCustomPopup();
  };

  const submitCustomModal = () => {
    Loader(true);
    stopBackgroundScrolling(false);
    const formValue = { ...contactFormState };
    const payload = prepareKdmDetailsPayload(formValue);
    // const params = {};
    const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
    updateOrderForSummary(payload, orderAuthToken).then(
      (resp: any) => {
        // console.log(resp, "API respone");
        // setTimeout(() => {
        //   closeCustomPopup();
        // }, 3000);
        KdmInfoSetter();
        closeCustomPopup();
      },
      (error: any) => {
        handleError(error);
        setShowError(true);
        // closeCustomPopup();
      }
    );
    // console.log(order)
    // reRenderComponent();
  };

  const getDefaultContactInfo = () => {
    setContactFormState({
      ...contactFormState,
      emailAddress: {
        ...contactFormState.emailAddress,
        value: kdmInfoObj.email
      },
      phoneNumber: {
        ...contactFormState.phoneNumber,
        value: kdmInfoObj.phoneNumber
      },
      fullName: {
        ...contactFormState.fullName,
        value: kdmInfoObj.firstName + ' ' + kdmInfoObj.lastName
      }
    });
  };

  useEffect(() => {
    // console.log(kdmInfoObj);
    // console.log(contactFormState, "Contact")
    getDefaultContactInfo();
    stopBackgroundScrolling(true);
    onLoad && onLoad();
  }, []);

  const isProceedDisabled = () => {
    const filteredFields = getVisibleFormFields({ ...contactFormState });
    const isFormNotValid = !isFormValid(filteredFields);

    return isFormNotValid || disableBtn;
  };

  return (
    <React.Fragment>
      <div className="modal-custom open">
        <div className="modal_dialog contract_modal" style={{ maxWidth: '60%' }}>
          <div className="modal_content">
            <div className="modal_header">
              <h5>{customPopupTitle ? customPopupTitle : 'Proceed to Booking Summary'}</h5>
            </div>
            <div
              className="modal_body"
              style={{
                paddingTop: '20px',
                flexDirection: 'row',
                flexWrap: 'wrap'
              }}
            >
              <FormBuilder formConfig={contactFormState} onSubmit={onSubmitContact} onChange={onContactFieldChange}></FormBuilder>
            </div>
            <div>
              <div style={{ display: 'flex', width: '100%', alignItems: 'center', marginTop: '-30px' }}>
                {showError && (
                  <div style={{ width: '70%', paddingLeft: '25px' }}>
                    <p style={{ color: 'red' }}>* Some Error occured pls try again</p>
                  </div>
                )}
                <div className="next_step" style={{ justifyContent: 'flex-end', marginBottom: '10px' }}>
                  <Button disabled={isLoading} variant="outlinebtn" onClick={closeCustomModal}>
                    Cancel
                  </Button>
                  <Button variant="activebtn" onClick={submitCustomModal} disabled={isProceedDisabled()}>
                    Update
                    {isLoading && <span className="loading_icon"></span>}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomModalKdm;
